
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import AtlasFilesActivitiesTimelineItem from "./AtlasFilesActivitiesTimelineItem.vue";
interface IAtlasFilesActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "AtlasFilesAllActivitiesView",
  components: { AtlasFilesActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): IAtlasFilesActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
        DELETE_FILE_SUCCESS,
        DELETE_FILE_FAILURE,
        FILE_UPLOAD_SUCCESS,
        FILE_UPLOAD_FAILURE
          `.replace(/\s/g, ""),
        activityType: "FileAccessActivity"
      };
    }
  }
});
